{
  "application/pdf": ["pdf"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    "docx"
  ],
  "application/vnd.ms-excel": "xls",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
    "xlsx",
    "xls"
  ],
  "image/png": ["png"],
  "image/jpeg": ["jpeg", "jpg"],
  "image/gif": ["gif"],
  "application/vnd.ms-outlook": ["msg"]
}
